import React, { useState } from "react"
import PropTypes from "prop-types"

const CopiarNit = ({ nit, mostrar = true }) => {
  const [copiado, setCopiado] = useState(false)

  const copiar = async e => {
    e.stopPropagation()
    if (!nit) return
    try {
      await navigator.clipboard.writeText(nit)
      setCopiado(true)
      setTimeout(() => setCopiado(false), 1500)
    } catch {
      const ta = document.createElement("textarea")
      ta.value = nit
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand("copy"); setCopiado(true); setTimeout(() => setCopiado(false), 1500) }
      catch { /* noop */ }
      document.body.removeChild(ta)
    }
  }

  if (!nit) return null

  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      fontSize: 13, fontFamily: "ui-monospace, SFMono-Regular, monospace",
      color: "#0f172a",
    }}>
      {mostrar && <span>{nit}</span>}
      <button
        type="button"
        onClick={copiar}
        title={copiado ? "Copiado" : "Copiar NIT"}
        style={{
          background: "none", border: "none", padding: 0, cursor: "pointer",
          color: copiado ? "#10b981" : "#94a3b8",
          display: "inline-flex", alignItems: "center",
          transition: "color 0.15s",
        }}
      >
        <i className={`mdi mdi-${copiado ? "check" : "content-copy"}`} style={{ fontSize: 14 }} />
      </button>
    </span>
  )
}

CopiarNit.propTypes = { nit: PropTypes.string, mostrar: PropTypes.bool }

export default CopiarNit
